import React from 'react'
import PropTypes from 'prop-types'
import convert from 'htmr'
import check from 'media/check.svg'
import useBreakpoints from '../../../hooks/useBreakpoints'

export default function TextBlock({ listItems }) {
  return (
    convert(listItems, {
      transform: {
        li: ListItem,
        p: 'span',
      },
    }) || null
  )
}

TextBlock.propTypes = {
  listItems: PropTypes.string,
}

function ListItem(props) {
  const { LG } = useBreakpoints()

  return (
    <li
      className="mb-16 px-30 pt-4 leading-body lg:mb-24 lg:px-36"
      style={{
        background: `url(${check}) 0 8px no-repeat`,
        backgroundSize: LG ? 'auto' : '18px',
      }}
    >
      <div className="s-text">{props.children}</div>
    </li>
  )
}

ListItem.propTypes = {
  children: PropTypes.any,
}
